import { render, staticRenderFns } from "./passwordfree.vue?vue&type=template&id=96309976&scoped=true"
import script from "./passwordfree.vue?vue&type=script&lang=js"
export * from "./passwordfree.vue?vue&type=script&lang=js"
import style0 from "./passwordfree.vue?vue&type=style&index=0&id=96309976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96309976",
  null
  
)

export default component.exports